import { Flow_0_0_2 } from '@flexus/core';

export const SIL_68: Flow_0_0_2 = {
	id: '68',
	name: 'private_work_sil_notifiction',
	itemType: 'flow',
	header: {
		title: '',
		controls: () => () => []
	},
	footer: {
		type: 'node_nav'
	},
	instructions: {
		editRoles: {
			0: 'Close the job'
		},
		viewRoles: {
			0: '--'
		}
	},
	startNode: '',
	nodes: {}
};
